'use client'

import { useEffect } from 'react'
import { holdStatusBarOverDark } from '@/lib/native/system-bars'

/** White status bar icons while a dark surface is mounted under the bar (native only). */
export function useStatusBarOverDark(active = true) {
  useEffect(() => {
    if (!active) return
    return holdStatusBarOverDark()
  }, [active])
}
